import './MainButton.scss'
const MainButton = ({text, link}) => {
    return (
        <div className="main-button">
            <a href={link} target="_blank" rel="noreferrer" title="">{text}</a>
        </div>
    )
 }
 export default MainButton